import React, { useState, useEffect } from "react";
import Select, { ActionMeta, SingleValue } from "react-select";

interface Option {
  label: string;
  value: string;
}

const conceptOptions: Option[] = [
  { label: "Complemento", value: "Complemento" },
  { label: "Compras", value: "Compras" },
  { label: "Entrada en efectivo", value: "Entrada en efectivo" },
  { label: "Mensualidad", value: "Mensualidad" },
  { label: "Retirada de caja", value: "Retirada de caja" },
  { label: "Sesión", value: "Sesión" },
];

function CustomSelectWidget(props: any) {
  const { id, value, required, disabled, readonly, onChange } = props;
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);

  useEffect(() => {
    const currentSelectedOption = conceptOptions.find(
      (option) => option.value === value
    );
    setSelectedOption(currentSelectedOption || null);
  }, [value]);

  const handleOnChange = (
    newValue: SingleValue<Option>,
    actionMeta: ActionMeta<Option>
  ) => {
    const selectedOption = newValue as Option | null;
    setSelectedOption(selectedOption);
    const model = selectedOption?.value ?? null;
    onChange(model);
  };

  const selectStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: "#E7F5F2",
      backgroundColor: "#E7F5F2",
      borderRadius: "0.25rem",
    }),
  };

  return (
    <Select
      id={id}
      options={conceptOptions}
      value={selectedOption}
      required={required}
      isDisabled={disabled || readonly}
      onChange={handleOnChange}
      styles={selectStyles}
      placeholder="Selecciona un concepto"
      isClearable={true}
    />
  );
}

function ConceptSelector(props: any) {
  const { id, options, value, required, disabled, readonly, onChange } = props;
  return (
    <CustomSelectWidget
      id={id}
      options={options?.enumOptions}
      value={value}
      required={required}
      disabled={disabled}
      readonly={readonly}
      onChange={onChange}
    />
  );
}

export default ConceptSelector;
